import { indexTopics } from '@/mocks/homeData';

export default function Index() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              吃瓜专题合集
            </h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
              按话题分类浏览，快速找到你最感兴趣的吃瓜内容
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
            {indexTopics.map((topic) => (
              <a
                key={topic.title}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group relative bg-background-100 rounded-xl overflow-hidden cursor-pointer"
              >
                <div className="relative w-full aspect-[4/3] bg-background-200 overflow-hidden">
                  <img
                    src={topic.image}
                    alt={topic.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                  {topic.tag && (
                    <span className="absolute top-2 right-2 px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                      {topic.tag}
                    </span>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                  <h3 className="font-heading text-sm md:text-base text-background-50 mb-1">
                    {topic.title}
                  </h3>
                  <span className="text-xs text-background-300">
                    {topic.count}条爆料
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}